<template>
    <div class="container lnb d_container">
        <div class="contents_wrap">
            <div class="contents list-container">
                <div class="title">
                    충전 / 출금관리
                </div>
                <div class="write_tab">
                    <div class="write_tab_content tab_contents" @click="movePage(`/service/payment`)">
                        충전
                    </div>
                    <div class="write_tab_content tab_contents active">
                        출금요청
                    </div>
                    <div class="write_tab_content tab_contents"  @click="movePage(`/service/payment/diposit`)">
                        직접입금
                    </div>

                </div>
                <div>
                    <point-list-component point-type="withdraw"></point-list-component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PointListComponent from "@/components/point/PointListComponent";
export default {
  name: "PaymentWithdraw",
  mixins: [],
  components: {
      PointListComponent
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
  },
  data() {
    return{
    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{
      movePage(url){
          this.$router.push(url)
      },
  },
  watch: {

  },
}
</script>

<style scoped>

</style>
